// Each project is served from its own subdomain (por.endur.io, voco.endur.io).
// Off endur.io (localhost, previews) the same pages live under /por/ and /voco/.

export const DOMAIN = "endur.io";
export const PROJECTS = ["por", "voco"];

const hostname = () =>
  typeof window === "undefined" ? "" : window.location.hostname;

export const isProduction = () =>
  hostname() === DOMAIN || hostname().endsWith(`.${DOMAIN}`);

// The project this hostname serves, or null for the team home.
export const hostProject = () => {
  const sub = hostname().slice(0, -(DOMAIN.length + 1));
  return isProduction() && PROJECTS.includes(sub) ? sub : null;
};

export const projectURL = (project: string, rest = "") =>
  isProduction() ? `https://${project}.${DOMAIN}/${rest}` : `/${project}/${rest}`;

// Resolves a root-relative link to the team home, from any subdomain.
export const homeURL = (href: string) =>
  hostProject() && href.startsWith("/") ? `https://${DOMAIN}${href}` : href;
